import { useState } from "react";

import { TextToolState } from "@impero-com/ui";
import { Row } from "@tanstack/react-table";

import { useUpdateUserGroupRightsForUserMutation } from "org/user/queries/useUpdateUserGroupRightsForUserMutation";

import { GroupRow } from "./useUserGroupsListTable";

interface UseRemoveGroupAccessRightUtilsProps {
    userId: number;
    selectedRows: Row<GroupRow>[];
    deselectAll: () => void;
}

export function useRemoveGroupAccessRightUtils({
    userId,
    selectedRows,
    deselectAll,
}: UseRemoveGroupAccessRightUtilsProps) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { mutateAsync, isPending } =
        useUpdateUserGroupRightsForUserMutation();

    const removeAccessRightToolState: TextToolState =
        selectedRows.length === 0 ? { type: "DISABLED" } : { type: "ENABLED" };

    const removeAccessRight = async () => {
        const userGroupIds = selectedRows.map((row) => row.original.id);
        try {
            await mutateAsync({
                userId,
                data: { newUserId: null, userGroupIds },
            });
            deselectAll();
            setIsModalOpen(false);
        } catch (error) {
            console.error("Failed to remove access right:", error);
        }
    };

    return {
        removeAccessRightToolState,
        isRemoveAccessRightModalOpen: isModalOpen,
        openRemoveAccessRightModal: () => setIsModalOpen(true),
        closeRemoveAccessRightModal: () => setIsModalOpen(false),
        removeAccessRight,
        isRemovingAccessRight: isPending,
    };
}
